import React from 'react'
import { shallow, mount } from 'enzyme'
import { MockedProvider } from "react-apollo/test-utils"
import { Row } from '../Row'
import business from './testData/business'
import years from './testData/years'
import interimPeriods from './testData/interimPeriods'
import getYearSources from '../helpers/getYearSources'
import cashflowNotes from '../configs/cashflow_notes.json'

const category = {
  'key': 'gross_revenue',
  title: 'Gross Revenue',
  'required': true,
  derived: false,
  '__typename': 'FinancialReviewCategory'
}
const tabIndices = {}
describe('<Row />', () => {
  const noop = () => {}
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      data: [],
      title: category.title,
      years,
      fiscalYears: business.fiscalYears,
      interimPeriods,
      yearSources: getYearSources({years, entity: business}),
      cellRef: noop,
      category,
      tabIndices
    }
    wrapper = shallow(<Row {...props} />)
    instance = wrapper.instance()
  })
  it('renders a title', () => {
    const wrapper = mount(
      <MockedProvider>
        <Row {...props} />
      </MockedProvider>
    )
    expect(wrapper.text()).toEqual(category.title)
  })
  describe('#getDerivedStateFromProps', () => {
    beforeEach(() => {
      props = {
        isEditable: true,
        data: []
      }
      wrapper = shallow(
        <MockedProvider>
          <Row {...props} />
        </MockedProvider>
      )
    })
    it('should set isEditable to true if it received an isEditable prop of true', () => {
      const newState = Row.getDerivedStateFromProps(props, {})
      expect(newState.isEditable).toBeTruthy()
    })
    it('should recalculate whether or not there are discrepancies in the row', () => {
      // hasDiscrepancy will be false because we are passing an empty data array via props
      const newState = Row.getDerivedStateFromProps(props, {})
      expect(newState.hasDiscrepancy).toBeFalsy()
    })
  })
  describe('#renderHelperLine', () => {
    describe('when selectedYear is a tax year', () => {
      beforeEach(() => {
        props = {
          ...props,
          isEditable: true,
          selectedCategory: category.key,
          selectedYear: 2016
        }
        wrapper = shallow(<Row {...props} />)
        instance = wrapper.instance()
      })
      it('returns a helper line displaying the correct information', () => {
        const selectedYear = 2016
        const helperLine = mount(instance.renderHelperLine())
        expect(helperLine.text()).toBe(cashflowNotes[years.get(selectedYear).taxReturn.formName][category.key])
      })
    })
    describe('when selectedYear is an interim year', () => {
      beforeEach(() => {
        props = {
          ...props,
          years: new Map([[2018, { period: 'interim' }]]),
          isEditable: true,
          selectedCategory: category.key,
          selectedYear: 2018
        }
        wrapper = shallow(<Row {...props} />)
        instance = wrapper.instance()
      })
      it('returns nothing', () => {
        expect(instance.renderHelperLine()).toBeFalsy()
      })
    })
  })
})
